import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationBar = ({ notifications = [] }) => {
  const mockNotifications = [
    {
      id: 1,
      type: 'urgent',
      icon: 'AlertCircle',
      message: 'عميل جديد في انتظار الرد - أحمد محمد',
      timestamp: new Date(Date.now() - 300000),
      unread: true
    },
    {
      id: 2,
      type: 'info',
      icon: 'MessageSquare',
      message: '5 رسائل واتساب جديدة',
      timestamp: new Date(Date.now() - 600000),
      unread: true
    },
    {
      id: 3,
      type: 'success',
      icon: 'CheckCircle',
      message: 'تم إرسال رسالة المتابعة إلى 12 عميل',
      timestamp: new Date(Date.now() - 900000),
      unread: false
    },
    {
      id: 4,
      type: 'warning',
      icon: 'Clock',
      message: '3 مواعيد متابعة مجدولة اليوم',
      timestamp: new Date(Date.now() - 1200000),
      unread: true
    }
  ];

  const displayNotifications = notifications?.length > 0 ? notifications : mockNotifications;
  const unreadCount = displayNotifications?.filter(n => n?.unread)?.length;

  const getNotificationColor = (type) => {
    const colors = {
      urgent: 'text-error',
      warning: 'text-warning',
      success: 'text-success',
      info: 'text-primary'
    };
    return colors?.[type] || 'text-foreground';
  };

  const formatTimestamp = (date) => {
    const minutes = Math.floor((Date.now() - date?.getTime()) / 60000);
    if (minutes < 60) return `منذ ${minutes} دقيقة`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `منذ ${hours} ساعة`;
    return `منذ ${Math.floor(hours / 24)} يوم`;
  };

  return (
    <div className="bg-card border-b border-border shadow-warm-sm">
      <div className="px-4 md:px-6 lg:px-8 py-3 md:py-4">
        <div className="flex items-center justify-between mb-3 md:mb-4">
          <div className="flex items-center gap-2 md:gap-3">
            <Icon name="Bell" size={20} className="text-primary" />
            <h2 className="text-base md:text-lg font-heading font-semibold text-foreground">
              الإشعارات
            </h2>
            {unreadCount > 0 && (
              <span className="px-2 md:px-2.5 py-0.5 md:py-1 rounded-full bg-error text-error-foreground text-xs md:text-sm font-medium">
                {unreadCount}
              </span>
            )}
          </div>
          <button className="text-sm md:text-base text-primary hover:text-primary/80 transition-colors font-caption">
            تحديد الكل كمقروء
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 md:gap-3 lg:gap-4">
          {displayNotifications?.map((notification) => (
            <div
              key={notification?.id}
              className={`flex items-start gap-2 md:gap-3 p-2 md:p-3 rounded-lg transition-all duration-250 cursor-pointer hover:bg-muted ${
                notification?.unread ? 'bg-muted/50' : 'bg-background'
              }`}
            >
              <Icon
                name={notification?.icon}
                size={18}
                className={getNotificationColor(notification?.type)}
              />
              <div className="flex-1 min-w-0">
                <p className="text-xs md:text-sm text-foreground line-clamp-2 mb-1">
                  {notification?.message}
                </p>
                <span className="text-xs text-muted-foreground font-caption">
                  {formatTimestamp(notification?.timestamp)}
                </span>
              </div>
              {notification?.unread && (
                <div className="w-2 h-2 rounded-full bg-primary flex-shrink-0 mt-1" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotificationBar;